import React from 'react';
import { useTranslation } from 'react-i18next';
import { ViettelTendooAI, CloseIcon, MenuChatIcon, NewChatIcon } from '@assets/icon';
import './ChatHeader.scss';

interface ChatHeaderProps {
  onClose?: () => void;
  onMenuClick?: () => void;
  onNewChatClick?: () => void;
  showNewChat?: boolean;
  isAudioEnabled?: boolean;
  onToggleAudio?: () => void;
  isBotSpeaking?: boolean;
  onClickSetting?: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  onClose,
  onMenuClick,
  onNewChatClick,
  showNewChat = true,
}) => {
  const { t } = useTranslation();

  return (
    <div className="chat-header">
      <div className="chat-header-left">
        <button
          className="chat-header-icon-btn"
          type="button"
          onClick={onMenuClick}
          aria-label={t('common.menu', 'Menu')}
        >
          <MenuChatIcon />
        </button>
        <div className="chat-header-logo">
          <ViettelTendooAI />
        </div>
        {/*
          Tạm ẩn mute/setting theo thiết kế mới.
          Giữ lại props và logic liên quan để dễ bật lại trong tương lai.
          <button
            className={getSpeakerClassName()}
            onClick={onToggleAudio}
            data-tooltip-id="chatbot-tooltip"
            data-tooltip-content={isAudioEnabled ? t('common.mute', 'Tắt âm thanh') : t('common.unmute', 'Bật âm thanh')}
          >
            {isAudioEnabled ? <VolumeIcon /> : <VolumeMuteIcon />}
          </button>
          <button
            className="chat-header-icon-btn ml-2"
            onClick={onClickSetting}
            data-tooltip-id="chatbot-tooltip"
            data-tooltip-content={t('common.setting', 'Cài đặt')}
          >
            <SettingIcon />
          </button>
        */}
      </div>
      <div className="chat-header-right">
        {showNewChat && (
          <button
            className="chat-header-icon-btn"
            type="button"
            onClick={onNewChatClick}
            aria-label={t('common.newMessage', 'Tin nhắn mới')}
          >
            <NewChatIcon />
          </button>
        )}
        <button
          className="chat-header-icon-btn chat-header-close-btn"
          onClick={onClose}
          type="button"
          data-tooltip-id="chatbot-tooltip"
          data-tooltip-content={t('common.close', 'Đóng')}
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;


